import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { PropertySearchFiltersInput } from '__generated__/api';
import { getStarFilterInput } from './star-filter-input';
import { getAmenitiesInput } from './amenities-input';
import { getAccessibilityInput } from './accessibility-input';
import { getTravelerTypeInput } from './traveler-type-input';
import { getPropertyNameInput } from './property-name-input';
import { getStructureTypesInput } from './structure-types-input';
import { getNeighborhoodInput } from './neighborhood-input';
import { getReviewScoreRangeInput } from './review-score-filter-input';
import { getPointOfInterestInput } from './point-of-interest-input';
import { getPaymentTypeInput } from './payment-type-input';
import { getDealsFilterInput } from './deals-filter-input';
import { getPropertyStyleInput } from './property-style-input';

export const getFiltersInput = (searchCriteria: SearchCriteriaModel, sortAndFilterOptions: any): PropertySearchFiltersInput => {
  const starList = getStarFilterInput(searchCriteria, sortAndFilterOptions);
  const structureTypes = getStructureTypesInput(searchCriteria);
  const propertyName = getPropertyNameInput(searchCriteria);
  const neighborhood = getNeighborhoodInput(searchCriteria);
  const amenities = getAmenitiesInput(searchCriteria);
  const accessibility = getAccessibilityInput(searchCriteria);
  const travelerType = getTravelerTypeInput(searchCriteria);
  const reviewScore = getReviewScoreRangeInput(searchCriteria, sortAndFilterOptions);
  const poi = getPointOfInterestInput(searchCriteria);
  const paymentType = getPaymentTypeInput(searchCriteria);
  const deals = getDealsFilterInput(searchCriteria);
  const propertyStyles = getPropertyStyleInput(searchCriteria);

  return {
    starList,
    structureTypes,
    propertyName,
    neighborhood,
    amenities,
    accessibility,
    travelerType,
    reviewScore,
    poi,
    paymentType,
    deals,
    propertyStyles
  };
};
